import { completedDurationLabel, formatTimer } from './cardDetailUtils'

export default function CardTimePanel({
    t,
    card,
    timeLogs,
    activeTimer,
    viewSession,
    effectiveIsCompleted,
    effectiveTimerStartedAt,
}) {
    const trackedTime = effectiveIsCompleted
        ? completedDurationLabel(timeLogs, card)
        : formatTimer(activeTimer)

    return (
        <div className="cd-view-session" role="status">
            <div>
                <span className="cd-view-session-label">
                    {t('card.timer.viewSession', { defaultValue: 'Vizualizare live' })}
                </span>
                <strong>{formatTimer(viewSession?.elapsedSeconds || 0)}</strong>
            </div>
            <div className="cd-view-session-tracking">
                <span className="cd-view-session-label">{t('card.timer.heading')}</span>
                <strong className={effectiveTimerStartedAt ? 'running' : ''}>{trackedTime}</strong>
            </div>
        </div>
    )
}
